export const templates = {
    "1x4x3": [
        [
            {"id": "1row1col", "shape": "rect", "width": 12},
        ],
        [
            {"id": "2row1col", "shape": "standard", "width": 3},
            {"id": "2row2col", "shape": "standard", "width": 3},
            {"id": "2row3col", "shape": "standard", "width": 3},
            {"id": "2row4col", "shape": "standard", "width": 3}
        ],
        [
            {"id": "3row1col", "shape": "standard", "width": 3},
            {"id": "3row2col", "shape": "standard", "width": 3},
            {"id": "3row3col", "shape": "rect", "width": 6}
        ]
    ],
    "1x4x4": [
        [
            {"id": "1row1col", "shape": "rect", "width": 12}
        ],
        [
            {"id": "2row1col", "shape": "standard", "width": 3},
            {"id": "2row2col", "shape": "standard", "width": 3},
            {"id": "2row3col", "shape": "standard", "width": 3},
            {"id": "2row4col", "shape": "standard", "width": 3}
        ],
        [
            {"id": "3row1col", "shape": "standard", "width": 3},
            {"id": "3row2col", "shape": "standard", "width": 3},
            {"id": "3row3col", "shape": "standard", "width": 3},
            {"id": "3row4col", "shape": "standard", "width": 3}
        ]
    ],
    "3x3x4x4": [
        [
            {'id': '1row1col', 'shape': 'standard', 'width': 4},
            {'id': '1row2col', 'shape': 'standard', 'width': 4},
            {'id': '1row3col', 'shape': 'standard', 'width': 4}
        ],
        [
            {'id': '2row1col', 'shape': 'standard', 'width': 4},
            {'id': '2row2col', 'shape': 'standard', 'width': 4},
            {'id': '2row3col', 'shape': 'standard', 'width': 4}
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 3},
            {'id': '3row2col', 'shape': 'standard', 'width': 3},
            {'id': '3row3col', 'shape': 'standard', 'width': 3},
            {'id': '3row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '4row1col', 'shape': 'standard', 'width': 3},
            {'id': '4row2col', 'shape': 'standard', 'width': 3},
            {'id': '4row3col', 'shape': 'standard', 'width': 3},
            {'id': '4row4col', 'shape': 'standard', 'width': 3}
        ]
    ],
    "4x4x4x4": [
        [
            {'id': '1row1col', 'shape': 'standard', 'width': 3},
            {'id': '1row2col', 'shape': 'standard', 'width': 3},
            {'id': '1row3col', 'shape': 'standard', 'width': 3},
            {'id': '1row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '2row1col', 'shape': 'standard', 'width': 3},
            {'id': '2row2col', 'shape': 'standard', 'width': 3},
            {'id': '2row3col', 'shape': 'standard', 'width': 3},
            {'id': '2row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 3},
            {'id': '3row2col', 'shape': 'standard', 'width': 3},
            {'id': '3row3col', 'shape': 'standard', 'width': 3},
            {'id': '3row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '4row1col', 'shape': 'standard', 'width': 3},
            {'id': '4row2col', 'shape': 'standard', 'width': 3},
            {'id': '4row3col', 'shape': 'standard', 'width': 3},
            {'id': '4row4col', 'shape': 'standard', 'width': 3}
        ]
    ],
    "3x4x3": [
        [
            {'id': '1row1col', 'shape': 'standard', 'width': 4},
            {'id': '1row2col', 'shape': 'standard', 'width': 4},
            {'id': '1row3col', 'shape': 'standard', 'width': 4}
        ],
        [
            {'id': '2row1col', 'shape': 'standard', 'width': 3},
            {'id': '2row2col', 'shape': 'standard', 'width': 3},
            {'id': '2row3col', 'shape': 'standard', 'width': 3},
            {'id': '2row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 4},
            {'id': '3row2col', 'shape': 'standard', 'width': 4},
            {'id': '3row3col', 'shape': 'standard', 'width': 4}
        ]
        ],
    "3x4x4": [
        [
            {'id': '1row1col', 'shape': 'standard', 'width': 4},
            {'id': '1row2col', 'shape': 'standard', 'width': 4},
            {'id': '1row3col', 'shape': 'standard', 'width': 4}
        ],
        [
            {'id': '2row1col', 'shape': 'standard', 'width': 3},
            {'id': '2row2col', 'shape': 'standard', 'width': 3},
            {'id': '2row3col', 'shape': 'standard', 'width': 3},
            {'id': '2row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 3},
            {'id': '3row2col', 'shape': 'standard', 'width': 3},
            {'id': '3row3col', 'shape': 'standard', 'width': 3},
            {'id': '3row4col', 'shape': 'standard', 'width': 3}
        ]
    ],
    "2x2x4x4": [
        [
            {'id': '1row1col', 'shape': 'rect', 'width': 6},
            {'id': '1row2col', 'shape': 'rect', 'width': 6}
        ],
        [
            {'id': '2row1col', 'shape': 'rect', 'width': 6},
            {'id': '2row2col', 'shape': 'rect', 'width': 6}
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 3},
            {'id': '3row2col', 'shape': 'standard', 'width': 3},
            {'id': '3row3col', 'shape': 'standard', 'width': 3},
            {'id': '3row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '4row1col', 'shape': 'standard', 'width': 3},
            {'id': '4row2col', 'shape': 'standard', 'width': 3},
            {'id': '4row3col', 'shape': 'standard', 'width': 3},
            {'id': '4row4col', 'shape': 'standard', 'width': 3}
        ]
    ],
    "4x4x4": [
        [
            {'id': '1row1col', 'shape': 'standard', 'width': 3},
            {'id': '1row2col', 'shape': 'standard', 'width': 3},
            {'id': '1row3col', 'shape': 'standard', 'width': 3},
            {'id': '1row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '2row1col', 'shape': 'standard', 'width': 3},
            {'id': '2row2col', 'shape': 'standard', 'width': 3},
            {'id': '2row3col', 'shape': 'standard', 'width': 3},
            {'id': '2row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 3},
            {'id': '3row2col', 'shape': 'standard', 'width': 3},
            {'id': '3row3col', 'shape': 'standard', 'width': 3},
            {'id': '3row4col', 'shape': 'standard', 'width': 3}
        ]
    ],
    "1x4": [
        [
            {'id': '1row1col', 'shape': 'rect', 'width': 12}
        ],
        [
            {'id': '2row1col', 'shape': 'standard', 'width': 3},
            {'id': '2row2col', 'shape': 'standard', 'width': 3},
            {'id': '2row3col', 'shape': 'standard', 'width': 3},
            {'id': '2row4col', 'shape': 'standard', 'width': 3}
        ]
    ],
    "2x3x3": [
        [
            {'id': '1row1col', 'shape': 'standard', 'width': 6},
            {'id': '1row2col', 'shape': 'standard', 'width': 6}
        ],
        [
            {'id': '2row1col', 'shape': 'rect', 'width': 4},
            {'id': '2row2col', 'shape': 'rect', 'width': 4},
            {'id': '2row3col', 'shape': 'rect', 'width': 4}
        ],
        [
            {'id': '3row1col', 'shape': 'rect', 'width': 4},
            {'id': '3row2col', 'shape': 'rect', 'width': 4},
            {'id': '3row3col', 'shape': 'rect', 'width': 4}
        ],
    ],
    "3x3x3": [
        [
            {'id': '1row1col', 'shape': 'standard', 'width': 4},
            {'id': '1row2col', 'shape': 'standard', 'width': 4},
            {'id': '1row3col', 'shape': 'standard', 'width': 4}
        ],
        [
            {'id': '2row1col', 'shape': 'standard', 'width': 4},
            {'id': '2row2col', 'shape': 'standard', 'width': 4},
            {'id': '2row3col', 'shape': 'standard', 'width': 4}
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 4},
            {'id': '3row2col', 'shape': 'standard', 'width': 4},
            {'id': '3row3col', 'shape': 'standard', 'width': 4}
        ]
    ],
    "FLYER-QUARTER_1_1_LEFT": [
        [
            {'id': '1row1col', 'shape': 'standard', 'width': 6},
            {'id': '1row2col', 'shape': 'rect', 'width': 12},
            {'id': '2row1col', 'shape': 'rect', 'width': 12},
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 3},
            {'id': '3row2col', 'shape': 'standard', 'width': 3},
            {'id': '3row3col', 'shape': 'standard', 'width': 3},
            {'id': '3row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '4row1col', 'shape': 'standard', 'width': 3},
            {'id': '4row2col', 'shape': 'standard', 'width': 3},
            {'id': '4row3col', 'shape': 'standard', 'width': 3},
            {'id': '4row4col', 'shape': 'standard', 'width': 3}
        ]
    ],
    "FLYER-QUARTER_1_1_RIGHT": [
        [
            {'id': '1row1col', 'shape': 'rect', 'width': 12},
            {'id': '2row1col', 'shape': 'rect', 'width': 12},
            {'id': '1row2col', 'shape': 'standard', 'width': 6}
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 3},
            {'id': '3row2col', 'shape': 'standard', 'width': 3},
            {'id': '3row3col', 'shape': 'standard', 'width': 3},
            {'id': '3row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '4row1col', 'shape': 'standard', 'width': 3},
            {'id': '4row2col', 'shape': 'standard', 'width': 3},
            {'id': '4row3col', 'shape': 'standard', 'width': 3},
            {'id': '4row4col', 'shape': 'standard', 'width': 3}
        ]
    ],
    "FLYER-QUARTER_2_2_LEFT": [
        [
            {'id': '1row1col', 'shape': 'standard', 'width': 6},
            {'id': '1row2col', 'shape': 'standard', 'width': 6},
            {'id': '1row3col', 'shape': 'standard', 'width': 6},
            {'id': '2row1col', 'shape': 'standard', 'width': 6},
            {'id': '2row2col', 'shape': 'standard', 'width': 6}
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 3},
            {'id': '3row2col', 'shape': 'standard', 'width': 3},
            {'id': '3row3col', 'shape': 'standard', 'width': 3},
            {'id': '3row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '4row1col', 'shape': 'standard', 'width': 3},
            {'id': '4row2col', 'shape': 'standard', 'width': 3},
            {'id': '4row3col', 'shape': 'standard', 'width': 3},
            {'id': '4row4col', 'shape': 'standard', 'width': 3}
        ]
    ],
    "FLYER-QUARTER_2_2_RIGHT": [
        [
            
            {'id': '1row1col', 'shape': 'standard', 'width': 6},
            {'id': '1row2col', 'shape': 'standard', 'width': 6},
            {'id': '2row1col', 'shape': 'standard', 'width': 6},
            {'id': '2row2col', 'shape': 'standard', 'width': 6},
            {'id': '1row3col', 'shape': 'standard', 'width': 6},
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 3},
            {'id': '3row2col', 'shape': 'standard', 'width': 3},
            {'id': '3row3col', 'shape': 'standard', 'width': 3},
            {'id': '3row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '4row1col', 'shape': 'standard', 'width': 3},
            {'id': '4row2col', 'shape': 'standard', 'width': 3},
            {'id': '4row3col', 'shape': 'standard', 'width': 3},
            {'id': '4row4col', 'shape': 'standard', 'width': 3}
        ]
    ],
    "2x4x4": [
        [
            {'id': '1row1col', 'shape': 'standard', 'width': 6},
            {'id': '1row2col', 'shape': 'standard', 'width': 6}
        ],
        [
            {'id': '2row1col', 'shape': 'standard', 'width': 3},
            {'id': '2row2col', 'shape': 'standard', 'width': 3},
            {'id': '2row3col', 'shape': 'standard', 'width': 3},
            {'id': '2row4col', 'shape': 'standard', 'width': 3}
        ],
        [
            {'id': '3row1col', 'shape': 'standard', 'width': 3},
            {'id': '3row2col', 'shape': 'standard', 'width': 3},
            {'id': '3row3col', 'shape': 'standard', 'width': 3},
            {'id': '3row4col', 'shape': 'standard', 'width': 3}
        ]
    ]

};

export const templateIds = {
    "1x4x3": ["1row1col", "2row1col", "2row2col", "2row3col", "2row4col", "3row1col", "3row2col", "3row3col"],
    "1x4x4": ["1row1col", "2row1col", "2row2col", "2row3col", "2row4col", "3row1col", "3row2col", "3row3col", "3row4col"],
    "3x3x4x4": ["1row1col", "1row2col", "1row3col", "2row1col", "2row2col", "2row3col", "3row1col", "3row2col", "3row3col", "3row4col", "4row1col", "4row2col", "4row3col", "4row4col"],
    "4x4x4x4": ["1row1col", "1row2col", "1row3col", "1row4col", "2row1col", "2row2col", "2row3col", "2row4col", "3row1col", "3row2col", "3row3col", "3row4col", "4row1col", "4row2col", "4row3col", "4row4col"],
    "3x4x3": ["1row1col", "1row2col", "1row3col", "2row1col", "2row2col", "2row3col", "2row4col", "3row1col", "3row2col", "3row3col"],
    "3x4x4": ["1row1col", "1row2col", "1row3col", "2row1col", "2row2col", "2row3col", "2row4col", "3row1col", "3row2col", "3row3col", "3row4col"],
    "2x2x4x4": ["1row1col", "1row2col", "2row1col", "2row2col", "3row1col", "3row2col", "3row3col", "3row4col", "4row1col", "4row2col", "4row3col", "4row4col"],
    "4x4x4": ["1row1col", "1row2col", "1row3col", "1row4col", "2row1col", "2row2col", "2row3col", "2row4col", "3row1col", "3row2col", "3row3col", "3row4col"],
    "1x4": ["1row1col", "2row1col", "2row2col", "2row3col", "2row4col"],
    "FLYER-QUARTER_1_1_LEFT": ["1row1col", "1row2col", "2row1col", "3row1col", "3row2col", "3row3col", "3row4col", "4row1col", "4row2col", "4row3col", "4row4col"],
    "FLYER-QUARTER_1_1_RIGHT": ["1row1col", "2row1col", "1row2col", "3row1col", "3row2col", "3row3col", "3row4col", "4row1col", "4row2col", "4row3col", "4row4col"],
    "FLYER-QUARTER_2_2_LEFT": ["1row1col", "1row2col", "1row3col", "2row1col", "2row2col", "3row1col", "3row2col", "3row3col", "3row4col", "4row1col", "4row2col", "4row3col", "4row4col"],
    "FLYER-QUARTER_2_2_RIGHT": ["1row1col", "1row2col", "2row1col", "2row2col", "1row3col", "3row1col", "3row2col", "3row3col", "3row4col", "4row1col", "4row2col", "4row3col", "4row4col"],
    "2x4x4": ["1row1col", "1row2col", "2row1col", "2row2col", "2row3col", "2row4col", "3row1col", "3row2col", "3row3col", "3row4col"]
};

export const templateList = [
    {"name": "1x4x3"},
    {"name": "1x4x4"},
    {"name": "3x3x4x4"},
    {"name": "4x4x4x4"},
    {"name": "3x4x3"},
    {"name": "3x4x4"},
    {"name": "2x2x4x4"},
    {"name": "4x4x4"},
    {"name": "1x4"},
    {"name": "2x3x3"},
    {"name": "3x3x3"},
    {"name": "FLYER-QUARTER_1_1_LEFT"},
    {"name": "FLYER-QUARTER_1_1_RIGHT"},
    {"name": "FLYER-QUARTER_2_2_LEFT"},
    {"name": "FLYER-QUARTER_2_2_RIGHT"},
    {"name": "2x4x4"}
];